export default __webpack_public_path__ + "static/media/linux.df61a02f.svg";